import {
  LeftOutlined,
  RightOutlined,
  UsergroupAddOutlined,
} from '@ant-design/icons';
import { Button, Tooltip } from 'antd';

import { TABLET } from '@app/constants';
import { useWindowSize } from '@app/hooks';

import { AddWorkScheduleModal } from '@pages/Calendar/ui/AddWorkScheduleModal';
import { ExecutorSelect } from '@pages/Calendar/ui/ExecutorSelect';

import { useCalendarHeader } from '../hooks';

import { CalendarHeaderSettings } from './CalendarHeaderSettings';
import { CalendarHeaderStats } from './CalendarHeaderStats';

import type { FC } from 'react';

import '../styles/CalendarHeader.scss';

export const CalendarHeader: FC = () => {
  const { innerWidth } = useWindowSize();

  const hideActionLabels = innerWidth <= 1200 && innerWidth > TABLET;

  const {
    selectedDateTitle,
    isTodaySelected,
    goToPrevDayHandler,
    goToNextDayHandler,
    returnToTodayHandler,
    hasUserRightToAddExecutor,
    IsFinancialStatistics,
    dateString,
    financialStatistics,
    isFinancialStatisticsLoading,
    isAddEmployeeModalOpen,
    isAddEmployeeModalLoading,
    employeesWithoutWorkSchedule,
    handleOpenAddEmployeeModal,
    handleCloseAddEmployeeModal,
  } = useCalendarHeader();

  return (
    <>
      <div className="CalendarHeader" data-testid="calendar-header">
        <div className="CalendarHeader__section CalendarHeader__section--left">
          <div className="CalendarHeader__date-controls">
            <Button
              className="CalendarHeader__arrow-button"
              onClick={goToPrevDayHandler}
              data-testid="calendar-header-prev-day"
              aria-label="Перейти к предыдущему дню"
            >
              <LeftOutlined />
            </Button>

            <div
              className="CalendarHeader__date-title"
              data-testid="calendar-header-date-title"
            >
              {selectedDateTitle}
            </div>

            <Button
              className="CalendarHeader__arrow-button"
              onClick={goToNextDayHandler}
              data-testid="calendar-header-next-day"
              aria-label="Перейти к следующему дню"
            >
              <RightOutlined />
            </Button>
          </div>

          {!isTodaySelected && (
            <Button
              className="CalendarHeader__today-button"
              onClick={returnToTodayHandler}
              data-testid="calendar-header-return-to-today"
            >
              К сегодня
            </Button>
          )}
        </div>

        <div className="CalendarHeader__section CalendarHeader__section--center">
          <ExecutorSelect />
        </div>

        <div className="CalendarHeader__section CalendarHeader__section--right">
          {IsFinancialStatistics && (
            <div className="CalendarHeader__action CalendarHeader__action--stats">
              <CalendarHeaderStats
                financialStatistics={financialStatistics}
                isLoading={isFinancialStatisticsLoading}
                dateString={dateString}
                showText={!hideActionLabels}
              />
            </div>
          )}

          {hasUserRightToAddExecutor && (
            <div className="CalendarHeader__action CalendarHeader__action--add-performer">
              <Tooltip title="Добавить исполнителя">
                <Button
                  icon={<UsergroupAddOutlined />}
                  className="CalendarHeader__add-performer-button"
                  data-testid="calendar-header-add-performer"
                  onClick={handleOpenAddEmployeeModal}
                >
                  {/* {hideActionLabels ? null : 'Добавить исполнителя'} */}
                </Button>
              </Tooltip>
            </div>
          )}
          <div className="CalendarHeader__action CalendarHeader__action--settings">
            <CalendarHeaderSettings />
          </div>
        </div>
      </div>

      {isAddEmployeeModalOpen && (
        <AddWorkScheduleModal
          isOpen={isAddEmployeeModalOpen}
          employees={employeesWithoutWorkSchedule}
          isEmployeeOptionsLoading={isAddEmployeeModalLoading}
          onClose={handleCloseAddEmployeeModal}
        />
      )}
    </>
  );
};
